const dic = JSON.parse(localStorage.dic);
import { filterTime } from '@/api/filter';
const IFA_RANK = dic['IFA_RANK'];
export const config = {
  mixins: [],
  data() {
    return {
      columns: [],
      extraColumns: []
    };
  },
  methods: {
    // 获取表格列
    getColumns() {
      let columns = [
        {
          title: '姓名',
          align: 'center',
          key: 'owerName',
          minWidth: 100,
          fixed: 'left'
        },
        
        {
          title: '件数',
          align: 'center',
          key: 'policyNum',
          minWidth: 90
        },
        {
          title: '保费合计(美元)',
          align: 'center',
          key: 'feeSum',
          minWidth: 120
        },
        {
          title: '佣金合计(港币)',
          align: 'center',
          key: 'commissionSum',
          minWidth: 120
        },
        {
          title: '销售佣金',
          align: 'center',
          key: 'salesCommission',
          minWidth: 120
        },
        {
          title: '推荐奖',
          align: 'center',
          key: 'recommendBonus',
          minWidth: 120
        },
        {
          title: '辅导奖',
          align: 'center',
          key: 'tutorBonus',
          minWidth: 120
        },
        {
          title: '管理津贴',
          align: 'center',
          key: 'teamBonus',
          minWidth: 120
        },
        {
          title: '育成奖',
          align: 'center',
          key: 'trainBonus',
          minWidth: 120
        },
        {
          title: '年度个人Bonus',
          align: 'center',
          key: 'personalBonus',
          minWidth: 130
        },
        {
          title: '入职时间',
          align: 'center',
          key: 'entryTime',
          minWidth: 120,
          render(h, params) {
            let entryTime = params.row.entryTime;
            return <span>{filterTime(entryTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '是否active状态',
          align: 'center',
          key: 'activeStatus',
          minWidth: 140,
          renderHeader: (h, params) => {
            return (
              <Poptip trigger="hover" content="content" transfer={true}>
                <span>是否active状态</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <p>上一季度是否为active状态</p>
                </div>
              </Poptip>
            );
          },
          render(h, params) {
            let activeStatus = params.row.activeStatus;
            return <span>{activeStatus == 1 ? '是' : '否'}</span>;
          }
        },
        {
          title: '当前职级',
          align: 'center',
          key: 'ifaLevel',
          minWidth: 120,
          render(h, params) {
            const value = params.row.ifaLevel;
            let ifaLevelMap = {
              0: '',
              1: '萌新',
              2: '新贵',
              3: '精英',
              4: '王者'
            };
            return <span>{ifaLevelMap[value]}</span>;
          }
        },
        {
          title: '是否团队长',
          align: 'center',
          key: 'isLeader',
          minWidth: 110,
          render(h, params) {
            let isLeader = params.row.isLeader;
            return <span>{isLeader == 1 ? '是' : '否'}</span>;
          }
        },
        {
          title: '推荐人',
          align: 'center',
          key: 'refereeName',
          minWidth: 100
        },
        {
          title: '辅导人',
          align: 'center',
          key: 'mentorName',
          minWidth: 100
        },
        {
          title: '团队长',
          align: 'center',
          key: 'leaderName',
          minWidth: 100
        },
        {
          title: '育成人',
          align: 'center',
          key: 'trainerName',
          minWidth: 100
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          fixed: 'right',
          minWidth: 80
        }
      ];
      this.columns = columns;

      this.extraColumns = [
        {
          title: 'IFA',
          align: 'center',
          key: 'owerName',
          minWidth: 120,
          fixed: 'left'
        },
        {
          title: '职级',
          align: 'center',
          key: 'owerLevel',
          minWidth: 120,
          render(h, params) {
            const value = params.row.owerLevel;
            let ifaLevelMap = {
              0: '',
              1: '萌新',
              2: '新贵',
              3: '精英',
              4: '王者'
            };
            return <span>{ifaLevelMap[value]}</span>;
          }
        },
        {
          title: '收入积分（港币）',
          align: 'center',
          key: 'incomes',
          minWidth: 140
        },
        {
          title: '支出积分（港币）',
          align: 'center',
          key: 'expenses',
          minWidth: 140
        },
        {
          title: '积分合计（港币）',
          align: 'center',
          key: 'settleCommissionPrice',
          minWidth: 140
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          fixed: 'right',
          minWidth: 80
        }
      ];
    }
  }
};
